<template>
  <div :class="{
    'supima-menu': callerComp === 'supimaMenu',
    'winter-menu': callerComp === 'winterWearMenu',
    'supima-submenu': callerComp === 'supimaSubMenu',
    'activewear-menu': callerComp === 'activeWearMenu',
    'activewear-sub-menu': callerComp === 'activeWearSubMenu',
    'activewear-cust-sub-menu': callerComp === 'activeWearCustSubMenu',
    'birthday-logo' : isBirthdayMonth && !isExclusive
  }">
    <div id="notifylogin" class="notifylogin">&nbsp;</div>
    <div class="loadingInterceptor" v-if="loading">
      <div class="loading"></div>
    </div>
    <div
      v-if="!(['supimaMenu', 'winterWearMenu',  'supimaSubMenu', 'activeWearMenu', 'activeWearSubMenu'].includes(callerComp))"
      id="topbar"
      class="topbar"
      :class="{'padding-y-3': !isComboActive, 'd-flex align-items-center goAppOnlySale': bannerPlaceHolderForGoForAppOnlySale}"
    >
      <div class="container" v-if="!isCodCheckoutLogin">
        <div class="row" :class="bannerPlaceHolderForGoForAppOnlySale ? 'float-right' : ''">
          <div :class="isComboActive ? 'topheader68' : 'col-md-12 text-right'">
            <ul class="top_nav55" data-testid="floornav" v-if="isComboActive && !bannerPlaceHolderForGoForAppOnlySale">
              <li v-if="showWomenWebMenu" :class="[webcategory === 'women' ? 'activeCat':'']">
                <router-link to="/women">WOMEN </router-link>
              </li>
              <li v-if="showMenWebMenu" :class="[webcategory === 'men' ? 'activeCat':'']">
                <router-link to="/men">MEN </router-link>
              </li>
              <li v-if="showKidsWebMenu && bannerPlaceHolderForKidsWebCategory && !isSelectedCountryIndia" :class="[webcategory === 'kids' ? 'activeCat':'']">
                <router-link to="/kids">
                  Kids
                </router-link>

              </li>
              <li v-if="showKidsWebMenu && bannerPlaceHolderForKidsWebCategory && isSelectedCountryIndia" :class="[webcategory === 'sneakers' ? 'activeCat':'']">
                <router-link to="/sneakers">
                  Sneakers
                </router-link>

              </li>
            </ul>
          <div class="d-flex align-items-center" :class="isComboActive ? 'top_rightnav66' : ''">
            <LocationChange/>
            <router-link to="/orders" class="pointer text-uppercase"><span @click="topMenuEventHandler('Track Order')">Track Order</span></router-link>
            <router-link to="/contact-us" class="pointer text-uppercase"><span @click="topMenuEventHandler('Contact Us')">Contact Us</span></router-link>
            <a v-if="!bannerPlaceHolderForGoForAppOnlySale && isSelectedCountryIndia" @click="redirectToAppStore" class="pointer text-uppercase d-inline-flex align-items-center">
              <i class="fa fa-mobile mr-1" style="font-size: 18px" aria-hidden="true"></i>
              Download App 
            </a>
          </div>
          </div>
        </div>
      </div>
    </div>
    <nav class="navbar navbar-toggleable-md navbar-light bg-faded navbarzindex navbar-min-height" :class="{'navAppOnly' :bannerPlaceHolderForGoForAppOnlySale, 'bg-inverse': isPosLogin}">
      <div :class="windowWidth > 1920 ? 'container-fluid custom-container' : ''">
        <button class="navbar-toggler navbar-toggler-left mobilenav" type="button">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div v-if="!(['supimaSubMenu', 'activeWearSubMenu'].includes(callerComp))" v-show="!bannerPlaceHolderForGoForAppOnlySale" class="headerRight" :class="{'bg-inverse' : isPosLogin}">
          <div>
            <ul :class="hideMenuByPage($route.name)" class="navbar-nav">
              <li>
                <div class="search-wrapper">
                <div class="search"> 
                    <autocomplete :trigger="trigger" :searchTerm="value" :callerComp="callerComp"></autocomplete>
  <!--                    <input type="search" id="search" placeholder="What are you looking for?" v-model="value" @keyup="search" @blur="searchFocus" autocomplete="off"/>-->
  <!--                    <span class="fa fa-search icon" @click="submitSearch"></span>-->
                </div> 
                </div>
              </li>
              <li class="nav-item navicon dropdown iconlink">
                <a class="nav-link naviconTitle dropdown-toggle" href="javascript:void(0)" id="navbarDropdownuser"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="gotoUrl('orders')"
                  v-if="authStatus" :title="userAcc.getuserName">
                  <span v-if="isExclusive">
                    <img src="./assets/images/mship-profile.svg" alt="wishlist" width="24" height="24" />
                  </span>
                  <span v-else class="hicon fa fa-user-o"></span>
                  <div class="count" style="top:11px;" v-if="(getPlatformCounts('TSS_MONEY') || getPlatformCounts('TSS_POINTS')) > 0">
                    {{ getPlatformCounts('TSS_MONEY') + getPlatformCounts('TSS_POINTS') }}
                  </div>
                </a>
                <span class="nav-link noTdropdown" @click="redirectToLogin" v-else>
                  <span class="hicon fa fa-user-o"></span>
                </span>
                <div class="dropdown-menu right" aria-labelledby="navbarDropdownuser" v-if="authStatus">
                  <router-link to="/orders" class="dropdown-item '+this.$router.currentRoute+'"><span @click="profileEventsHandler('Orders')">Orders</span></router-link>
                  <router-link to="/my-gift-voucher" v-if="isSelectedCountryIndia" class="dropdown-item"><span @click="profileEventsHandler('Gift Vouchers')">Gift Vouchers</span></router-link>
                  <router-link to="/my-reward-points/money" v-if="isSelectedCountryIndia" class="dropdown-item">
                    <span @click="profileEventsHandler('TSS Money')">
                      TSS Money
                    </span>
                    <span class="badge badge-danger rounded-circle" title="Expiring soon" v-if="getPlatformCounts('TSS_MONEY') > 0">
                      {{ getPlatformCounts('TSS_MONEY') }}
                    </span>
                  </router-link>
                  <router-link to="/my-reward-points/points" v-if="isSelectedCountryIndia" class="dropdown-item">
                    <span @click="profileEventsHandler('TSS Points')">
                      TSS Points
                    </span>
                    <span class="badge badge-danger rounded-circle" title="Expiring soon" v-if="getPlatformCounts('TSS_POINTS') > 0">
                      {{ getPlatformCounts('TSS_POINTS') }}
                    </span>
                  </router-link>
                  <router-link to="/my-saved-cards" v-if="isSelectedCountryIndia" class="dropdown-item"><span @click="profileEventsHandler('Saved Cards')">Saved Cards</span></router-link>
                  <a @click="sideMenu('/profile')" class="dropdown-item pointer profile" :class="this.$route.path === '/profile' ? 'profileactive' : ''"><span>Profile</span></a>
                  <router-link to="/faqs" class="dropdown-item"><span @click="profileEventsHandler('FAQs')">FAQs</span></router-link>
                  <router-link to="/artwork-sale" class="dropdown-item" v-if="user.user_type == 3"><span @click="profileEventsHandler('Artwork Sales')">Artwork Sales</span></router-link>
                  <div class="dropdown-item pointer " @click="handlelogout">Logout</div>   
                </div>
              </li>
              <li class="nav-item navicon" v-if="!disableWishlist">
                <a class="nav-link dropdown-toggle" id="navbarDropdownuser" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="wishlistEvent">
                  <span v-if="isExclusive">
                    <img src="./assets/images/mship-wishlist.svg" alt="wishlist" width="24" height="24" />
                  </span>
                  <span v-else class="headercart hicon fa" :class="this.$router.currentRoute.path === '/mywishlist' ? 'fa-heart-o active' : 'fa-heart-o'"></span>
                  
                  <div class="count" style="top:8px;" v-if="wishlistCount > 0">{{ wishlistCount }}</div>
                </a>
              </li>
              <li class="nav-item navicon" v-if="cartcount>0">
                <!-- <router-link :to="'/cart'" class="nav-link dropdown-toggle" id="navbarDropdownuser" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false" @click="cartEvent">
                  <span class="headercart hicon fa fa-shopping-cart"></span>
                  <div class="count" style="top:8px;">{{isMystery ? cartcount - 1 : cartcount }}</div>
                </router-link> -->
                <a class="nav-link dropdown-toggle" id="navbarDropdownuser" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="cartEvent">
                  <!-- <span class="headercart hicon fa fa-shopping-cart"></span> -->
                  <!-- <img data-src="https://tss-static-images.gumlet.io/icons/cart-icon.png" class="bagIcon"/> -->
                  <span v-if="isExclusive">
                    <img src="./assets/images/mship-cart.svg" alt="Cart" width="24" height="24" class="headercart" />
                  </span>
                  <span v-else>
                    <svg xmlns="http://www.w3.org/2000/svg"
                      class="headercart"
                      width="25"
                      height="23"
                      viewBox="0 0 48 48"
                      :style="['supimaMenu', 'activeWearMenu', 'winterWearMenu'].includes(callerComp) ? 'stroke: #fff;fill: #fff;stroke-width:1.4;-webkit-font-smoothing: antialiased;' : 'stroke: rgb(114 107 107);fill: rgb(34 32 32);stroke-width:1.4;-webkit-font-smoothing: antialiased;'"
                    >
                      <path xmlns="http://www.w3.org/2000/svg"
                        d="M43,46H5c-2.209,0-4-1.791-4-4l4-24c0.678-3.442,2.668-4,4.877-4h2.652  C14.037,7.052,18.602,2,24,2s9.963,5.052,11.471,12h2.652c2.209,0,4.199,0.558,4.877,4l4,24C47,44.209,45.209,46,43,46z M24,4  c-4.352,0-8.045,4.178-9.418,10h18.837C32.045,8.178,28.353,4,24,4z M41,18c-0.308-1.351-0.957-2-2.37-2h-2.828  C35.925,16.976,36,17.975,36,19c0,0.552-0.447,1-1,1s-1-0.448-1-1c0-1.027-0.069-2.031-0.201-3H14.201C14.07,16.969,14,17.973,14,19  c0,0.552-0.447,1-1,1s-1-0.448-1-1c0-1.025,0.075-2.024,0.197-3H9.369C7.957,16,7.309,16.649,7,18L3,42c0,1.104,0.896,2,2,2h38  c1.104,0,2-0.896,2-2L41,18z"
                        shape-rendering="auto"
                      />
                      <line x1="5" y1="32" x2="44" y2="32" style="stroke-width:3;"/>
                    </svg>
                  </span>
                  <div class="count" style="top:11px;">{{isMystery ? cartcount - 1 : cartcount }}</div>
                </a>
              </li>
              <li class="nav-item navicon" v-else>
                <router-link :to="'/cart'" class="nav-link dropdown-toggle" id="navbarDropdownuser" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false" aria-label="cart icon">
                  <svg xmlns="http://www.w3.org/2000/svg"
                    class="headercart"
                    width="25"
                    height="23"
                    viewBox="0 0 48 48"
                    :style="['supimaMenu', 'activeWearMenu', 'winterWearMenu'].includes(callerComp) ? 'stroke: #fff;fill: #fff;stroke-width:1.4;-webkit-font-smoothing: antialiased;' : 'stroke: rgb(114 107 107);fill: rgb(34 32 32);stroke-width:1.4;-webkit-font-smoothing: antialiased;'"
                    @click="cartIconEventHandler"
                  >
                    <path xmlns="http://www.w3.org/2000/svg"
                      d="M43,46H5c-2.209,0-4-1.791-4-4l4-24c0.678-3.442,2.668-4,4.877-4h2.652  C14.037,7.052,18.602,2,24,2s9.963,5.052,11.471,12h2.652c2.209,0,4.199,0.558,4.877,4l4,24C47,44.209,45.209,46,43,46z M24,4  c-4.352,0-8.045,4.178-9.418,10h18.837C32.045,8.178,28.353,4,24,4z M41,18c-0.308-1.351-0.957-2-2.37-2h-2.828  C35.925,16.976,36,17.975,36,19c0,0.552-0.447,1-1,1s-1-0.448-1-1c0-1.027-0.069-2.031-0.201-3H14.201C14.07,16.969,14,17.973,14,19  c0,0.552-0.447,1-1,1s-1-0.448-1-1c0-1.025,0.075-2.024,0.197-3H9.369C7.957,16,7.309,16.649,7,18L3,42c0,1.104,0.896,2,2,2h38  c1.104,0,2-0.896,2-2L41,18z"
                      shape-rendering="auto"
                    />
                    <line x1="5" y1="32" x2="44" y2="32" style="stroke-width:3;"/>
                  </svg>
                  <!-- <span class="headercart hicon fa fa-shopping-cart"></span>  -->
                  <!-- <img data-src="https://tss-static-images.gumlet.io/icons/cart-icon.png" class="bagIcon"/> -->
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div
          v-if="!['supimaMenu', 'activeWearMenu', 'winterWearMenu', 'supimaSubMenu', 'activeWearSubMenu'].includes(callerComp)"
          class="pointer"
          @click="homeEventhandler(webcategory && isComboActive ?'/'+webcategory:'/')"
          :class="webcategory ?'navbar-brand':'navbar-brand logo55'"
        >
        </div>
        <span v-else-if="['supimaMenu', 'activeWearMenu', 'winterWearMenu'].includes(callerComp)" @click="handleMenu" class='pabsolute menu-hamburger d-flex align-items-center h-100 pointer'>
          <img src='./assets/images/hamburger-white.png'/>
        </span>
        <div v-if="!bannerPlaceHolderForGoForAppOnlySale" class="collapse navbar-collapse stylescrollbar navMenu" id="navbarNavDropdown" >
          <div class="navheader showmobile">
            <button class="back_mobile mobilenav" type="button">
              <span class="fa fa-angle-left"></span>
            </button>
            <router-link to="/" class="navbar-brand slidem text-center">&nbsp;</router-link>
          </div>
          <ul v-if="!(this.$route.path === '/' && isComboActive)" :class="hideMenuByPage($route.name)" v-navFontAdjustment  class="navbar-nav nav-list-wrapper">
            <div v-for="(item,index)  in menuData" :key="index" class="nav-list"> 
            <li v-if=" item.web_dropdown" class="nav-item dropdown activeMenu">
              <div  class="nav-link dropdown-toggle pointer" style="font-size:14px" data-toggle="dropdown" aria-haspopup="true" :aria-controls="'collapse' + index" :href="`#collapse${index}`"
                  aria-expanded="false" @click="item.is_clickable && gotoRoute(item)">{{item.name}}
                  <sup v-if="item.has_tag" style="color:#f00"> {{item.tag_name}}</sup>
              </div>
              <div v-if="item.intrim_sub_category &&
                Object.keys(item.intrim_sub_category).length" :id="'collapse' + index"
                :class="{'dropdown-menu fullwidth deskFullWidth': item.isFullWidthWeb,'dropdown-menu deskDropMenu': !item.isFullWidthWeb}" 
                aria-labelledby="navbarDropdownMenuLink">
                <div :class="item.isFullWidthWeb ? 'submenucontainer': 'submenucontainer d-flex pt-0 pb-0'" style="width: 100% !important;">
                <ul v-if="!item.isFullWidthWeb" class="submenu mb-0">
                  <div>
                    <div style="padding-left: 0%;" >
                      <li  v-for="(catgoryItem,categoryIndex) in item.intrim_sub_category" class="itream-cat mbnav mbnav-nowrap" :key="categoryIndex" style="min-width: 118px;">
                        <a class="toggle-menu pointer intrim-pointer" style="color: #878787" active-class="active">{{catgoryItem.name}}
                          <sup v-if="catgoryItem.has_tag" style="color:#f00"> {{catgoryItem.tag_name}}</sup>
                            <div class="dropdown-sub-content submenucontainer itrem-submenucontainer" >
                              <ul class="submenu my-1" :class="catgoryItem.data.length > 4 ? ' itrem-submenu multi-column' : 'd-flex flex-column'">
                                <li class="mbnav mbnav-nowrap mr-2" v-for="(subcategoryItem, subcategoryIndex) in catgoryItem.data" :key="subcategoryIndex">
                                  <a class="toggle-menu pointer intrim-pointer" style="color: #878787" active-class="active" @click="gaEvents(subcategoryItem, item.name)">{{ subcategoryItem.name }}</a>
                                  <sup v-if="subcategoryItem.has_tag" style="color:#f00"> {{subcategoryItem.tag_name}}</sup>
                                </li>
                              </ul>
                            </div>
                        </a>
                      </li>
                    </div>
                  </div>
                </ul>
              </div>
            </div>
            <div  v-else-if="(item.categories && item.categories.length) || (item.sub_categories && item.sub_categories.length)" :id="'collapse' + index"
              :class="{'dropdown-menu fullwidth deskFullWidth': item.isFullWidthWeb,'dropdown-menu deskDropMenu': !item.isFullWidthWeb}" 
              aria-labelledby="navbarDropdownMenuLink"> 
              <div :class="item.isFullWidthWeb ? 'submenucontainer': 'submenucontainer d-flex pt-0 pb-0' ">
                <ul v-if="!item.isFullWidthWeb" class="submenu mb-0">
                    <div :style="`column-count:${item.categories && item.categories.length ? item.categories.length/columnLength : item.sub_categories && item.sub_categories.length ? item.sub_categories.length/columnLength : 2} `">
                      <div style="padding-left: 0%;" >
                        <li  v-for="(catgoryItem,categoryIndex) in (item.categories || item.sub_categories)" class="mbnav mbnav-nowrap" :key="categoryIndex">
                          <a class="toggle-menu pointer" active-class="active" @click="gaEvents(catgoryItem, item.name)">{{catgoryItem.name}}
                            <sup v-if="catgoryItem.has_tag" style="color:#f00"> {{catgoryItem.tag_name}}</sup>
                          </a>
                        </li>
                      </div>
                    </div>
                  </ul>
                  <div v-else class="container">
                    <div class="row">
                      <div  class="col-md-12 columncount" :class="item.name === 'Men' || item.name === 'Women' ? 'columnLayout col-md-8' : ''">
                        <div v-for="(catgoryItem,categoryIndex) in item.categories" :key="categoryIndex">
                          <h5 class="official-merch-space navsubtitle">
                        <router-link @click.native="headerMenuEventHandler(`${item.name} > ${catgoryItem.name}`, catgoryItem.is_clickable)" :to="catgoryItem.url_key && catgoryItem.is_clickable ? catgoryItem.url_key : '' " class="toggle-menu" active-class="active">{{catgoryItem.name}}
                        <sup v-if="catgoryItem.has_tag" style="color:#f00"> {{catgoryItem.tag_name}}</sup>
                        </router-link>
                        </h5>
                        <div v-if="catgoryItem.sub_categories && catgoryItem.sub_categories.length>0" class="row sublevel2">
                          <div class="col-xl-12 col-md-12 col-12">
                            <ul class="submenu mb-2 subcategories-margin">
                              <li  v-for="(subcategoryItem, index) in catgoryItem.sub_categories " :key="index">
                                  <a class="toggle-menu pointer" active-class="active" @click="subMenu(subcategoryItem, catgoryItem.name, item.name)"> {{ subcategoryItem.name }}
                                    <sup v-if="subcategoryItem.has_tag" style="color:#f00"> {{subcategoryItem.tag_name}}</sup>
                                  </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
            </div>
            </div>
            </li>
            <li v-else-if="item.name && item.name.toLowerCase().includes('membership') && ((exclusiveUser && item.merged_categories === 'exclusive_user') || !exclusiveUser && item.merged_categories === 'non_exclusive_user')" class="nav-item exclusive">
              <router-link @click.native="headerMenuEventHandler(item.name, true)" style="font-size:14px" :to="item.url_key || item.navigation || ''" class="nav-link" href="#">Membership
              <sup v-if="item.has_tag" style="color:#f00 "> {{item.tag_name}}</sup>
              </router-link>
            </li>
            <li v-else-if="item.name && !item.name.toLowerCase().includes('membership')" class="nav-item non-exc">
              <router-link @click.native="headerMenuEventHandler(item.name, true)" style="font-size:14px" :to="item.url_key || item.navigation || ''" class="nav-link">{{item.name}}
              <sup v-if="item.has_tag" style="color:#f00"> {{item.tag_name}}</sup>
              </router-link>
            </li>
            </div>
            <li class="nav-item dropdown showmobile" v-if="userAcc.authenticated">
              <div class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                My Account
              </div>
              <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <router-link to="/orders" class="dropdown-item citem">Orders</router-link>
                <!--<router-link to="/wishlist" class="dropdown-item citem">Wishlist</router-link>-->
                <!-- FIXME: -->
                <!--<router-link to="/my-gift-voucher" class="dropdown-item citem">Gift Vouchers</router-link>-->
                <router-link to="/my-reward-points/money" class="dropdown-item citem">TSS Money</router-link>
                <router-link to="/my-reward-points/points" class="dropdown-item citem">TSS Points</router-link>
                <router-link to="/profile" class="dropdown-item citem">Profile</router-link>
                <!-- <router-link to="/artwork-sale" class="dropdown-item citem" v-if="userAcc.isArt==3">Artwork Sales</router-link> -->
                <div class="dropdown-item citem pointer" @click="handlelogout">Logout</div>
              </div>
            </li>
            <li class="nav-item showmobile" v-else>
              <div class="nav-link" @click="redirectToLogin">
                Login
              </div>
            </li>
          </ul>
        </div>
        <div v-if="['supimaMenu', 'activeWearMenu', 'winterWearMenu'].includes(callerComp)" class='supima-home-logo pabsolute h-full d-flex justify-content-center align-items-center'>
          <router-link :to="webcategory && isComboActive ?'/'+webcategory:'/'">
            <div v-if="callerComp === 'winterWearMenu'" class="navbar-brand pointer"></div>
            <img v-else :src="callerComp === 'supimaMenu' ? imgBaseUrl + 'supima-home-logo.png' : imgBaseUrl + 'active-wear-logo.png'"/>
          </router-link>
        </div>
      </div>
    </nav>
    <login-modal v-if="loginModel" @close="userAcc.loginBox = false"></login-modal>
    <order-track v-if="oTrack" @close="oTrack= false"></order-track>
  </div>
</template>
<script>
  var $ = require('jquery')
  window.jQuery = $
  import auth from './auth/index.js'
  import Vue from 'vue'
  import store from './store/index'
  import {mapGetters} from 'vuex'
  const orderTrack = () => import('./components/widgets/orderTrack')
  const LoginModal = () => import('./components/common/LoginModal.vue')
  const autocomplete = () => import('./components/common/autocomplete')
  import LocationChange from './components/common/LocationChange.vue'

  var offm = {
    props: {
      dataname: String,
      dataurl: String
    },
    data () {
      return {
        searchTerm: '',
        trigger: false,
        linkarray: this.dataname.split(','),
        datalink: this.dataurl.split(','),
        linkpath: '/artists/'
      }
    },
    template: `<div class="sublevel2">
                <ul class="submenu">
                  <li v-for="(item, index) in linkarray">
                    <a href="https://www.thesouledtore.com" target="_blank" v-if="datalink[index] === 'wwe-official-merchandise'">{{ item}} </a>
                      <router-link :to="'/artists/'+ datalink[index]" v-else>{{ item}}<sup v-if="datalink[index] == 'toy-story-official-merchandise' || datalink[index] == 'the-lion-king-official-merchandise' || datalink[index] == 'official-merchandise-jabariya-jodi' || datalink[index] == 'official-merchandise-virender-sehwag' || datalink[index] == 'official-merchandise-kfc' || datalink[index] == 'judgementall-hai-kya' || datalink[index] == 'mickey-mouse-official-merchandise'" style="color:#f00; text-transform:capitalize"> New</sup> </router-link>
                  </li>
                </ul>
              </div>`
  }
  export default {
    name: 'app',
    components: {
      LoginModal,
      'off-nav': offm,
      orderTrack,
      autocomplete,
      LocationChange
    },
    props: ['callerComp', 'landingPageMenuData', 'handleMenu'],
    data () {
      return {
        userAcc: auth.user,
        ckAuth: auth,
        searchTerm: '',
        value: store.getters.getSearchKey,
        suggestionAttribute: 'product',
        selectedEvent: '',
        oTrack: false,
        count: 0,
        catImgPath: process.env.IMG_BASE_URL + process.env.CATEGORY_IMG,
        products: [],
        exclusiveEnabled: process.env.EXCLUSIVE_ENABLED,
        trigger: false,
        womenApparels: "WOMEN'S APPARELS",
        columnLength: 5,
        imgBaseUrl: process.env.STATIC_IMG_SERVER2,
        windowWidth: '' // Initialize with current window width
      }
    },
    methods: {
      updateWindowWidth: function () {
        this.windowWidth = window.innerWidth
        this.$forceUpdate()
      },
      handlelogout: function () {
        this.$store.dispatch('OPEN_LOGOUT_MODAL')
      },
      sideMenu: function (link) {
        this.profileEventsHandler('Profile')
        if (link === '/profile') {
          this.$store.commit('GTAG_EVENT', {eventName: 'profile', payload: {route: Vue.ls.get('routeObj')}})
          this.$router.push(link)
        }
      },
      homeEventhandler: function (path) {
        this.$store.dispatch('TATVIC_EVENT', {eventName: 'LOGO_CLICK', payload: {}})
        this.$router.push(path)
      },
      cartEvent: function () {
        this.cartIconEventHandler()
        this.$router.push({ name: 'cart' })
      },
      wishlistEvent: function () {
        const routeObj = Vue.ls.get('routeObj')
        // this.$store.commit('GTAG_EVENT', {eventName: 'CT_Go_to_Wishlist', payload: {pdp_response: Vue.ls.get('routeObj')}})
        // this.$store.commit('GTAG_EVENT', {eventName: 'Go_to_Wishlist', payload: {pdp_response: Vue.ls.get('routeObj')}})
        // this.$store.commit('GTAG_EVENT', {eventName: 'FB_Go_to_Wishlist', payload: {pdp_response: Vue.ls.get('routeObj')}})
        this.$store.commit('GTAG_EVENT', {eventName: `myWishlist_pageview`, payload: {visitFrom: Vue.ls.get('routeObj').current}})
        this.$store.dispatch('TATVIC_EVENT', {eventName: 'WISHLIST_REDIRECTION_CLICK',
          payload: {
            INTERACTION_TYPE: 'Icon Click'
          }
        })
        this.$store.commit('MOENGAGE_EVENT', {eventName: 'VIEW_WISHLIST',
          payload: {
            ...this.moengageImpressionData,
            Source: String(routeObj && routeObj.current)
          }}
          )
        this.$router.push({ name: 'mywishlist' })
      },
      directToVirtualStore: function () {
        let token = Vue.ls.get('tss_token')
        let email = Vue.ls.get('email')
        if (token && email) {
          window.open(`https://view.gmetri.com/v4/seymof/marvel_avengers_copy?token_tss=${token}&user_email=${email}`, '_blank')
        } else {
          this.$router.push(`/login?redirect=https://view.gmetri.com/v4/seymof/marvel_avengers_copy?token_tss=&newTab=true`)
        }
      },
      addEventsForTshirt (url) {
        switch (url) {
          case '/men/t-shirts':
            this.$store.commit('GTAG_EVENT', {eventName: 'men.tshirts.clicked', payload: {solid_slug: url}})
            break
          case '/women/t-shirts':
            this.$store.commit('GTAG_EVENT', {eventName: 'women.tshirts.clicked', payload: {solid_slug: url}})
            break
          default:
            break
        }
      },
      titleMatch (title) {
        return title.toLowerCase() === this.womenApparels.toLowerCase()
      },
      redirectToAppStore: function () {
        this.$store.commit('GTAG_EVENT', {eventName: 'App_Topbar_Click', payload: {}})
        if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
          this.topMenuEventHandler('Google Play Store')
          window.location.href = 'https://play.google.com/store/apps/details?id=com.thesouledstore'
        } else if (navigator.userAgent.toLowerCase().indexOf('iphone') > -1) {
          this.topMenuEventHandler('Apple App Store')
          window.location.href = 'https://apps.apple.com/in/app/thesouledstore/id1493897434'
        } else {
          this.topMenuEventHandler('Google Play Store')
          window.location.href = 'https://play.google.com/store/apps/details?id=com.thesouledstore'
        }
      },
      redirectToLogin () {
        this.$store.dispatch('TATVIC_EVENT', {eventName: 'HEADER_PROFILE', payload: {}})
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      },
      weblogout () {
        this.profileEventsHandler('Logout')
        this.logout()
        this.$store.dispatch('CLOSE_LOGOUT_MODAL')
        window.HaptikSDK.logout(function () {
          console.log('logout')
        })
      },
      logout () {
        // auth.logout(this, '/')
        this.$store.dispatch('BLACKLIST_LOGOUT').then(res => {
          this.$store.dispatch('LOGOUT', {
            requiresAuth: this.$route.meta.requiresAuth
          }).then(response => {
            this.$toasted.show((res && res.message) || 'You have been successfully logged out', {
              theme: 'primary',
              className: 'toasted-customred',
              position: 'top-right',
              duration: 5000
            })
            this.$store.dispatch('CART_DATA')
            this.$store.dispatch('WISHLIST_DATA')
            this.$store.state.auth.phoneNumber = ''
          })
        })
      },
      search: function (e) {
        if (!this.value) {
          this.value = ''
        } else {
          if (e.keyCode === 13) {
            store.state.searchKey = this.value
            store.dispatch('setSearchPageKey', this.value)
            // Vue.ls.set('tss_search_key', this.value, 30 * 60 * 1000)
            this.$router.push('/search?q=' + this.value)
          } else if (this.value.length > 2) {
            // this.$router.push('/search/' + this.value)
          }
        }
      },
      loginBoxModal () {
        this.$store.dispatch('SET_LOGINBOX', { flag: true })
      },
      clickInput: function () {
        this.selectedEvent = 'click input'
      },
      clickButton: function () {
        this.selectedEvent = 'click button'
      },
      selected: function () {
        this.selectedEvent = 'selection changed'
      },
      enter: function () {
        this.selectedEvent = 'enter'
        this.$router.push('/search?q=' + this.value)
        // this.value = ''
      },
      submitSearch: function () {
        if (this.value) {
          this.$router.push('/search?q=' + this.value)
        }
        // this.value = ''
      },
      keyUp: function () {
        this.selectedEvent = 'keyup pressed'
      },
      keyDown: function () {
        this.selectedEvent = 'keyDown pressed'
      },
      keyRight: function () {
        this.selectedEvent = 'keyRight pressed'
      },
      clear: function () {
        this.selectedEvent = 'clear input'
      },
      escape: function () {
        this.selectedEvent = 'escape'
      },
      trackModal () {
        this.oTrack = true
      },
      gotoUrl (url) {
        this.$store.commit('GTAG_EVENT', {eventName: 'HEADER_PROFILE', payload: {}})
        this.$router.push('/' + url)
      },
      gotoRoute (itemObj) {
        this.$store.commit('GTAG_EVENT', {eventName: 'exclusive-member', payload: {}})
        this.$store.commit('GTAG_EVENT', {eventName: 'themes', payload: {id: itemObj.name}})
        itemObj.url_key ? this.$router.push(itemObj.url_key) : ''
        this.headerMenuEventHandler(itemObj.name, itemObj.is_clickable)
      },
      gaEvents (catgoryItem, itemName) {
        if (catgoryItem && catgoryItem.if_kids_age) {
          let ageGroup = []
          ageGroup.push(catgoryItem.lower_kids_age)
          ageGroup.push(catgoryItem.upper_kids_age)
          if (ageGroup[0] !== ageGroup[1]) {
            this.$store.commit('SET_NAVIGATED_AGE_GROUP', ageGroup)
          }
        }
        this.$store.commit('GTAG_EVENT', {eventName: 'accessories', payload: {id: catgoryItem}})
        let url = catgoryItem.url_key && catgoryItem.is_clickable ? catgoryItem.url_key : ''
        this.$router.push(url)
        this.headerMenuEventHandler(`${itemName} > ${catgoryItem.name}`, catgoryItem.is_clickable)
      },
      subMenu (subcategoryItem, catgoryItemName, type) {
        let url = subcategoryItem.url_key && subcategoryItem.is_clickable ? subcategoryItem.url_key : ''
        if (type === 'Men') {
          this.$store.commit('GTAG_EVENT', {eventName: 'men', payload: {id: subcategoryItem.name}})
        } else if (type === 'Women') {
          this.$store.commit('GTAG_EVENT', {eventName: 'women', payload: {id: subcategoryItem.name}})
        } else if (type === 'Themes') {
          this.$store.commit('GTAG_EVENT', {eventName: 'themes', payload: {id: subcategoryItem.name}})
        }
        this.$router.push(url)
        this.headerMenuEventHandler(`${type} > ${catgoryItemName} > ${subcategoryItem.name}`, true)
      },
      menuClick () {
        this.$store.commit('SET_NAVIGATION_WIDGET', 'Menu')
      },
      onClickHeaderLogo () {
        window.open(process.env.TSS_URL, '_blank')
      },
      hideMenuByPage (url) {
        switch (url) {
          case 'cart':
            return 'invisible'
          case 'shipment':
            return 'invisible'
          case 'deliveryaddress':
            return 'invisible'
          case 'paymentoptions':
            return 'invisible'
          case 'thankyou':
            return 'invisible'
          case 'codcheckout':
            return 'invisible'
          default:
            return null
        }
      },
      profileEventsHandler (headerText) {
        headerText && headerText !== 'Logout' ? this.$store.dispatch('TATVIC_EVENT', {eventName: 'MY_ACCOUNT_INTERACTIONS',
          payload: {
            INTERACTION_MENU: headerText,
            INTERACTION_TYPE: 'Tray'
          }}
        ) : ''
        headerText && headerText === 'Logout' ? this.$store.dispatch('TATVIC_EVENT', {eventName: 'LOGOUT', payload: {INTERACTION_TYPE: 'Tray', USER_ID: 'NA'}}) : ''
      },
      topMenuEventHandler (menuText) {
        this.$store.dispatch('TATVIC_EVENT', {eventName: 'TOP_MENU_CLICK', payload: {CLICKED_TOP_MENU: menuText}})

        menuText === 'Contact Us' ? this.$store.commit('MOENGAGE_EVENT', {eventName: 'TRACK_CONTACT_US_SIDEMENU_CLICK',
          payload: {
            UserId: this.user && this.user.user_id ? this.user.user_id : 0,
            DateTime: new Date() && new Date().toISOString(),
            Platform: 'WEB',
            PageName: 'TopMenu'
          }}
        ) : ''
      },
      headerMenuEventHandler (headerText, isClickable) {
        if (isClickable) {
          this.$store.dispatch('TATVIC_EVENT', {eventName: 'NAVIGATION_MENU_CLICK', payload: {NAVIGATION_CATEGORY: headerText.replace('>', '|')}})
          this.$store.commit('SET_NAVIGATION_WIDGET', 'Menu')
          const categoryArr = headerText.split('>')
          this.$store.commit('MOENGAGE_EVENT', {eventName: 'MENU-LIST',
            payload: {
              Category: String(categoryArr[categoryArr.length - 1]),
              Section: String(categoryArr[0] === 'Men' || categoryArr[0] === 'Women' ? categoryArr[0] : 'Men'),
              Sub_Category: String(categoryArr[1])
            }}
          )
        }
      },
      cartIconEventHandler () {
        this.$store.commit('GTAG_EVENT', {eventName: 'CART_ICON_CLICK', payload: {}})
      },
      getPlatformCounts (str) {
        let counts = 0
        this.notificationData && this.notificationData.forEach(element => {
          if (element.platform === str) {
            counts = element.counts
          }
        })
        return counts
      }
    },
    directives: {
      // create a directive named 'elementLog'
      navFontAdjustment: {
        inserted: function (wrapper) {
          let fontSize = 100
          const childEl = document.getElementById('navbarNavDropdown')
          const myInterval = setInterval(() => {
            if ((wrapper.clientWidth > (childEl && childEl.clientWidth)) && fontSize > 0) {
              fontSize -= 2
              wrapper.style.fontSize = `${fontSize}%`
            } else {
              if ((wrapper.clientWidth > (childEl && childEl.clientWidth))) {
                wrapper.style.flexWrap = 'wrap'
              }
              clearInterval(myInterval)
            }
          }, 2)
        }
      }
    },
    mounted: function () {
      window.addEventListener('resize', this.updateWindowWidth)
      this.ckAuth.checkAuth()
      this.products = this._products
      if (this.authStatus) {
        this.$store.dispatch('GET_NOTIFICATIONS')
      }
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.updateWindowWidth)
    },
    computed: {
      ...mapGetters({
        loginModel: 'loginModelBox',
        authStatus: 'authStatus',
        cartcount: 'cartcount',
        loading: 'loading',
        _products: 'FETCH_PRODUCTS',
        isMystery: 'isMystery',
        user: 'user',
        isExclusive: 'isExclusive',
        exclusiveUser: 'exclusiveUser',
        navMenuData: 'navMenuData',
        webcategory: 'webcategory',
        bannerPlcaeHolderData: 'bannerPlcaeHolderData',
        isComboActive: 'isComboActive',
        wishlistCount: 'wishlistCount',
        disableWishlist: 'disableWishlist',
        supimaLandingData: 'supimaLandingData',
        isBirthdayMonth: 'isBirthdayMonth',
        notificationData: 'notificationData',
        isPosLogin: 'isPosLogin',
        isCodCheckoutLogin: 'isCodCheckoutLogin',
        isSelectedCountryIndia: 'isSelectedCountryIndia',
        globalBannerPlaceholder: 'globalBannerPlaceholder',
        getGlobalSettingKeys: 'getGlobalSettingKeys',
        moengageImpressionData: 'moengageImpressionData',
        hasAddressChanged: 'hasAddressChanged',
        countries: 'countries',
        country_detail_data: 'country_detail_data',
        confirmedLogout: 'confirmedLogout'
      }),
      // webcategoryforpdp: function () {
      //   if (this.$route.path.startsWith('/product') && Vue.ls.get('tss_landingCategory') === null) {
      //     return 'men'
      //   }
      //   return
      // },
      menuData () {
        if (this.landingPageMenuData) {
          return this.landingPageMenuData
        } else if (this.isComboActive && !(this.callerComp === 'supimaSubMenu' || this.callerComp === 'activeWearSubMenu')) {
          return this.genderSpecificNavData
        }
        return this.navMenuData
      },
      genderSpecificNavData () {
        let genderData
        if (this.webcategory === 'women') {
          genderData = this.navMenuData && this.navMenuData.find((itm) => itm.name === 'Women')
        } else if (this.webcategory === 'kids') {
          genderData = this.navMenuData && this.navMenuData.find((itm) => itm.name === 'Kids')
        } else {
          genderData = this.navMenuData && this.navMenuData.find((itm) => itm.name === 'Men')
        }
        return genderData && genderData.categories && [...genderData.categories, ...this.otherMenuNavData]
      },
      otherMenuNavData () {
        if (this.webcategory === 'kids') {
          return this.navMenuData && this.navMenuData.filter((itm) => itm.name !== 'Men' && itm.name !== 'Women' && itm.name !== 'Kids' && itm.name !== 'Supima Landing' && itm.name !== 'Activewear')
        }
        return this.navMenuData && this.navMenuData.filter((itm) => itm.name !== 'Men' && itm.name !== 'Women' && itm.name !== 'Kids')
      },
      bannerPlaceHolderForSneakersWebCategory: function () {
        return this.bannerPlcaeHolderData &&
          this.bannerPlcaeHolderData.length &&
          this.bannerPlcaeHolderData.find(bannerData =>
            (bannerData.placeholder_for || '').toLowerCase() === 'pdp screen' &&
            bannerData.status === true &&
            (bannerData.product_type || '').toLowerCase() === 'enable_sneaker_tab_web'
          )
      },
      bannerPlaceHolderForKidsWebCategory: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
          bannerData.product_type.toLowerCase() === 'SHOW_KIDSWEAR_WEBCATEGORY_WEB'.toLowerCase())
      },
      bannerPlaceHolderForGoForAppOnlySale: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
          bannerData.product_type.toLowerCase() === 'GO_APP_ONLY_SALE_WEB'.toLowerCase())
      },
      showWomenWebMenu: function () {
        return this.isSelectedCountryIndia ? true : this.globalBannerPlaceholder && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData => bannerData.is_active === true && bannerData.config_key === 'SHOW_WEB_MENU_WOMEN')
      },
      showMenWebMenu: function () {
        return this.isSelectedCountryIndia ? true : this.globalBannerPlaceholder && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData => bannerData.is_active === true && bannerData.config_key === 'SHOW_WEB_MENU_MEN')
      },
      showKidsWebMenu: function () {
        return this.isSelectedCountryIndia ? true : this.globalBannerPlaceholder && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData => bannerData.is_active === true && bannerData.config_key === 'SHOW_WEB_MENU_KIDS')
      },
      showPartialCart: function () {
        return this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData => bannerData.is_active === true && bannerData.config_key === 'SHOW_PARTIAL_CART')
      }
    },
    watch: {
      '$route' () {
        setTimeout(function () {
          $('.navbar-collapse').removeClass('activenav')
          $('.mobilesearch').removeClass('active')
        }, 300)
        $('.fullwidth.deskFullWidth').css('width', 'unset')
        $('.fullwidth.deskFullWidth').css('left', 'unset')
        if (this.$route.name !== 'search') {
          this.value = ''
        }
        if (this.authStatus) {
          this.$store.dispatch('GET_NOTIFICATIONS')
        }
      },
      confirmedLogout (newVal) {
        if (newVal) {
          this.weblogout()
          this.$store.dispatch('RESET_CONFIRMED_LOGOUT')
        }
      },
      hasAddressChanged: {
        handler: function () {
          Vue.ls.set('listing_meta_info', null)
          this.$set(this.$parent, 'loading', true)
          this.$store.dispatch('GET_HOME_SCREEN_DATA', {isComboActive: this.isComboActive})
          this.$store.dispatch('GET_NAVMENU_DATA')
          this.$store.dispatch('CART_DATA')
          this.$store.dispatch('WISHLIST_DATA')
          const countryId = this.$store.state.selectedCountryAddress.countryId
          const configKeys = this.getGlobalSettingKeys
          this.$store.dispatch('GLOBAL_GET_BANNERS_DATA', { countryId, configKeys })
        },
        deep: true
      }
    }
  }
</script>

<style lang="css" scoped>
  .topheader68{
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    padding: 0px 0 0px 50px;
    min-height: 45px;
    }
  .top_nav55 {display: flex; margin: 0px;}
  .top_nav55 li{align-items: center; list-style: none;border-right: 1px solid #525050;}
  .top_nav55 li:first-child{border-left: 1px solid #525050;}
  .top_nav55 li a{display: block; padding: 12px 20px; background: #ed2d2f; 
   color:#fff; font-family: futura-pt,sans-serif;
   font-weight: 900;
   font-size: .875rem; text-transform: uppercase;
   width: 112px; text-align: center; }
   .logo55 {bottom: -38px;}
  .top_nav55 li:hover a{ background-color: #df7c7c;}
  .top_nav55 li.activeCat a{background-color: #fff;color: rgba(88, 89, 91, 1) !important;}
.submenucontainer .submenu li {
  display: inline-block;
  width: 100%;
}

.itrem-submenucontainer {
  padding: 0 20px;
}

.fa-heart.active {
  color: #eb3e25 !important;
}
  .navbar-toggleable-md .navbar-collapse {
    width: 100%;
  }
  .navbarzindex {
    z-index: 101 !important; 
    /* higher z-index than play/pause button of videoplayer component */
  }
  .intrim-pointer:hover{
    color: #000000 !important;
  }

  .navbar-min-height {
    min-height: 58px
  }

  .headerRight .hicon{
    font-size: 24px;
  }

  .headerRight .fa-heart-o.active {
    color: #eb3e25;
  }

  .search-wrapper {
    margin: 10px auto;
    height: 42px;
    margin-right: 10px;
    cursor: pointer;
  }

  .search {
    vertical-align: middle;
    white-space: nowrap;
    position: relative;
  }
  .supima-home-logo {
    left: 43%
  }
  .activewear-menu .supima-home-logo {
    left: 44%;
  }
  .supima-home-logo img {
    height: 40px;
  }

  .search input#search {
    width: 40px;
    height: 40px;
    font-size: 14px;
    float: right;
    padding-left: 40px;
    border-radius: 5px;
    color: #262626;
    border: 1px solid transparent;
    transition: width .55s ease;
  }
  .search .icon{
    position: absolute;
    top: 50%;
    font-size: 22px;
    margin-top: 8px;
    z-index: 1;
    color: #4f5b66;
    right: 15px;
  }

  .dropdown-sub-content {
    display: none;
    min-width: 160px;
    min-height: 40px;
    width: auto;
    position: absolute;
    top: auto;
    margin-top: -35px;
    margin-left: 59%;
    /* bottom: 5%; */
    background-color: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  .itream-cat:hover .dropdown-sub-content {
    display: block;
  }

  .itrem-submenu {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .submenu.itrem-submenu.multi-column {
    grid-template-columns: repeat(2, 1fr);
  }

  .search input#search:focus,
  .search input#search:active {
    outline: none;
    width: 210px;
    padding-left: 15px;
    background: #eee;
  }

  .search:hover input#search,
  .search input#search:focus {
    width: 210px;
    padding-left: 15px;
    background: #eee;
  }

  .navbar-nav .nav-link {
    position: relative;
  }

  .nav-item.dropdown:not(.iconlink) .nav-link:before {
    display: block;
    position: absolute;
    right: 0px;
    font: normal normal normal 14px/1.5 FontAwesome;
    font-size: 15px;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    content: "\F107";
  }

  .sbx-google__input-placeholder {
    background: transparent;
  }
  .headerRight{
    background-color: #fff;
    max-height: -webkit-fill-available;
  }
  .supima-menu .headerRight {
    background-color: #e11b23;
  }
  .winter-menu {
    position: relative;
    z-index: 999;
  }
  .winter-menu .headerRight {
    background-color: #e11b23;
  }
  .activewear-menu .headerRight {
    background-color: #000000;
  }
  .headercart,
  .headerRight {
    top: 0px;
  }
  .goAppOnlySale {
    min-height: 3rem;
  }
  .fcapital {
    text-transform: capitalize;
  }

  .navbar {
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
    position: relative;
    z-index: 99;
  }
  .supima-submenu .navbar, .activewear-sub-menu .navbar {
    display: flex;
    justify-content: center;
  }
  .activewear-sub-menu {
    border-top: 6px solid #e93432;
  }

  .navbar.fixed-top {
    position: fixed;
  }
  .supima-submenu .navbar.fixed-top, .activewear-sub-menu .navbar.fixed-top{
    top: 54px;
    border-top: 6px solid #e93432;
  }

  .navbar.fixed-top .navbar-brand {
    width: 70px;
    height: 45px;
    top: 11px;
    left: 70px;
    -webkit-transition: all .2s ease-in-in;
    transition: all .2s ease-in-in
  }
  .supima-menu .menu-hamburger, .activewear-menu .menu-hamburger {
    left: 130px;
  }
  .winter-menu .menu-hamburger, .activewear-menu .menu-hamburger {
    left: 130px;
  }
  .supima-menu .menu-hamburger img, .activewear-menu .menu-hamburger img {
    height: 30px;
  }
  .winter-menu .menu-hamburger img, .activewear-menu .menu-hamburger img {
    height: 30px;
  }
  .supima-menu .navbar {
    background-color:#e11b23;
    min-height: 61px;
  }
  .winter-menu .navbar {
    background-color:#e11b23;
    min-height: 82px;
  }
  .winter-menu .navbar.fixed-top {
    min-height: 55px;
  }
  .activewear-menu .navbar {
    background-color: #000000;
    min-height: 61px;
  }

  .topbar {
    background:#e11b23;
    padding: 0px 0;
  }
  .padding-y-3{
    padding: 3px 0px;
  }

  #topbar .router-link-active {
    color: white;
  }

  .topbar a,
  .topbar span {
    color: #fff;
    padding-left: 15px;
    font-size: 13px;
  }

  .topbar a:hover {
    color: #fff;
  }
  .navAppOnly {
    min-height: 3.5rem;
  }
  .navMenu {
    padding-left: 200px;
  }
  .supima-submenu .navMenu, .activewear-sub-menu .navMenu {
    margin-left: 0;
  }

  .navicon a.dropdown-toggle,
  .navicon .noTdropdown {
    padding: 0 !important;
    margin: 0;
    width: 50px;
    text-align: center;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
  }

  .navicon a.dropdown-toggle .bagIcon {
    width: 24px;
    image-rendering: auto;
  }

  .navicon a .dropdown-menu {
    padding: 15px !important;
  }

  .navicon .dropdown-menu a {
    font-size: 15px !important;
  }

  .dropdown-menu.right {
    right: 0;
    left: inherit;
  }

  .dropdown-menu {
    padding: .5rem 0 0.4rem;
  }

  .dropdown-item.profile{
    cursor: pointer;
    color: #58595b !important;
  }

  .dropdown-item.profile:hover, .dropdown-item.profile.profileactive{
    color: #ed2d2f !important;
  }

  .dropdown-item.active,
  .dropdown-item:active,
  .dropdown-item:focus,
  .dropdown-item:hover {
    background-color: transparent;
  }

  a.router-link-exact-active.router-link-active:not(.headercart) {
    color: #ed2d2f;
  }
  .supima-menu a.router-link-exact-active.router-link-active:not(.headercart), .activewear-menu a.router-link-exact-active.router-link-active:not(.headercart) {
    color: #fff;
  }

  .winter-menu a.router-link-exact-active.router-link-active:not(.headercart), .activewear-menu a.router-link-exact-active.router-link-active:not(.headercart) {
    color: #fff;
  }
  .official-merch-space {
    padding: 0;

  }

  .top-margin {
    margin-bottom: 37px;
  }

  .bottom-margin {
    margin-top: -20px;
  }
  .subcategories-margin {
    margin-top: -10px;
  }
  @media screen and (min-width: 992px) {

    .topbar {
      height: 45px
    }

    .navbar-brand:not(.slidem):before {
      content: '';
      display: block;
      width: 23px;
      height: 16px;
      background: url('assets/images/eyes.png') no-repeat right;
      position: absolute;
      background-size: 100% auto;
      top: 25px;
      left: 17px;
    }
    .exclusive .navbar.fixed-top .navbar-brand::before {
          left: 12px !important;
          margin-top: -10px;
          width: 12px !important;
    }
    .navbar.fixed-top .navbar-brand::before {
          left: 8px !important;
          margin-top: -16px;
          width: 15px !important;
    }
    
  }

  @media screen and (max-width: 1200px) {

    .topbar {
      min-height: 53px
    }

    .navbar-toggleable-md .navbar-nav .nav-link {
      padding-right: .8rem;
      padding-left: .8rem;
      font-size: 14px;
    }

    .mobilesearch {
      width: 300px;
      margin-right: 8em;
    }
  }

  .notifylogin {
    position: fixed;
    top: 40px;
    background: #ed2d2f;
    width: 240px;
    padding: 10px;
    z-index: 999;
    right: 10px;
    visibility: hidden;
    opacity: 0;
    transition: all 1s ease-out;
    color: #fff;
    box-shadow: 0 0 3px rgba(0, 0, 0, .5)
  }

  .notifylogin.active {
    visibility: visible;
    opacity: 1;
    top: 90px;
    transition: all .5s ease-in
  }

  .locked-tag {
    color: #58595b;
    padding: 3px 0;
  }
  @media screen and (max-width: 1492px) {
    .navbar-toggleable-md .navbar-collapse {
      /*width: 67%;*/
    }
  }
  @media screen and (max-width: 1184px) {
    .navbar-toggleable-md .navbar-collapse {
      /*width: 62%;*/
    }
  }
  @media screen and (max-width: 991px) {
    .notifylogin.active {
      visibility: visible;
      opacity: 1;
      top: 60px;
    }

    .navbar-brand:before {
      top: 25px;
      left: 12px;
      width: 18px;
      height: 16px;
    }

    .nav-item.dropdown .nav-link:before {
      display: block;
      position: absolute;
      right: 15px;
      font: normal normal normal 14px/1.5 FontAwesome;
      font-size: 20px;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
      content: "\F107";
    }

    .dropdown-item.citem {
      font-size: 15px;
      padding: 0px 30px;
      line-height: 28px;
    }

    .navbar-nav {
      padding-bottom: 80px;
    }

    .navbar-collapse {
      top: -28px;
    }

    .navbar-collapse.activenav {
      box-shadow: 5px 0 8px rgba(0, 0, 0, .2);
    }

    .navbar.fixed-top .navbar-collapse {
      top: 0;
    }

    .navbar {
      height: 42px;
    }

    .navMenu {
      margin-left: 0px;
    }

    .navbar-brand {
      width: 87px;
      margin-left: auto;
      margin-right: auto;
      left: 50%;
      margin-left: -45px;
      top: -29px;
    }

    .navbar-brand.slidem {
      position: inherit;
      width: 90px;
      height: auto;
      margin-left: auto;
      left: inherit;
      top: inherit;
      margin-right: auto;
      bottom: 0px;
      background: url('assets/images/newlogosticky.png') center center no-repeat;
      background-size: 55% !important;
    }

    .navbar.fixed-top .navbar-brand {
      position: static;
      height: auto;
      bottom: 0;
      margin-left: auto;
    }
    .headerRight {
      top: 8px;
    }

    .mobilesearch {
      width: 100%;
    }

    #togglesearch {
      display: inline-block;
      text-decoration: none;
    }

    .mobilesearch {
      background: #58595b;
      position: absolute;
      width: 100%;
      padding: 10px;
      border-radius: 0;
      top: 40px;
      z-index: 9;
      left: 0;
      height: 60px;
      visibility: hidden;
      opacity: 0;
      -webkit-transition: all 0.3s ease-in;
      -moz-transition: all 0.3s ease-in;
      transition: all 0.3s ease-in;
    }

    .mobilesearch input:focus {
      outline: none;
    }

    .mobilesearch.active {
      visibility: visible;
      opacity: 1;
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      transition: all 0.3s ease-out;
    }

    .mobilesearch.active:before {
      content: '';
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid #58595b;
      position: absolute;
      top: -7px;
      right: 55px;
    }

    .searchinput {
      height: 100%;
      width: 85%;
      border: 0;
    }

    .mobilesearch .searchinput {
      padding: 10px;
    }

    .searchbutton {
      width: 15%;
      text-align: center;
      padding: 10px 0;
      float: right;
    }

    .mobilesearch .searchbutton {
      padding-top: 9px;
      cursor: pointer;
    }

    .mbinput {
      width: 100%;
      background: #fff;
      border-radius: 5px;
      border: 1px #117a7a solid;
    }

    .navbar-toggleable-md .navbar-nav .nav-link {
      margin-left: 0;
    }
    .columnLayout{
    margin: 0 auto;
    }
  }

  .roseAreRed {
    color: #FF0000 !important;;
  }

  .btn-danger {
    background-color: #ed2d2f;
    border-color: #ed2d2f;
  }

  .mbnav-nowrap {
    white-space: nowrap;
  }

  .columnLayout{
    column-count: unset !important;
    flex-direction: row;
    display: flex;
    float: none;
    justify-content: space-between;
    flex: 0 0 60% !important;
    max-width: 60% !important;
  }
  .columnLayout > div{
    flex: 1;
  }
   /* Header */


  .exclusive .navbar-brand {
    background: url('./assets/images/membership-logo.png') center center no-repeat;
    background-size: contain;
  }

  .birthday-logo .navbar-brand {
    background: url('https://prod-img.thesouledstore.com/public/theSoul/images/Welcome-100-web.png') center center no-repeat;
    background-size: contain;
    height: 81px;
  }

  .exclusive .navbar.fixed-top .navbar-brand {
    background: url('./assets/images/membership-logo.png') center center no-repeat;
    background-size: contain;
  }

  .birthday-logo .navbar.fixed-top .navbar-brand {
    background: url('https://prod-img.thesouledstore.com/public/theSoul/images/Welcome-100-web.png') center center no-repeat;
    background-size: contain;
    height: 81px;
  }
  .exclusive-congrats-msg {
    color: #e76a52;
    font-size: 40px;
    font-weight: bold;
    padding: 100px 0px;
  }
  .exclusive .navbar-brand:before {
    filter: brightness(0%);
    -webkit-filter: brightness(0%);
  }

  .exclusive .navbar.fixed-top .navbar-brand {
    height: 54px;
  }

  .exclusive .navbar-brand:not(.slidem):before {
    width: 15px;
    height: 16px;
    left: 28px;
    top: 20px;
  }

  .exclusive .search input#search {
    padding-left: 50px;
  }
</style>
<style>
.exclusive .top_nav55 li.activeCat a {
  color: #000 !important;
}
.exclusive .exclusive-topbar {
  background: #3E3F45;
}
.exclusive .exclusive-topbar .col-md-12 span span {
  background: -webkit-linear-gradient(#E1E3F6, #ECE7F6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.exclusive .exclusive-topbar .close span {
  color: #fff;
}
.exclusive .topbar {
  background: #000;
  border-bottom: 4px solid #ED2D2F;
}
.exclusive .top_nav55 {
  margin-bottom: -4px !important;
}
.exclusive .top_nav55 li {
  border-left-color: #f00;
}
.exclusive .top_nav55 li a {
  background: none;
  padding-bottom: 16px;
}
.exclusive .top_nav55 li a:hover {
  background: none;
}
.exclusive .top_nav55 li:first-child {
  border-left: none;
  border-right: 1px solid #525050;
}
.exclusive .top_nav55 li:last-child {
  border: none;
}
.exclusive .top_nav55 li.activeCat a {
  background: url('./assets/images/menu-link-bg.png');
  background-size: cover;
}
.exclusive .navbar-brand {
  top: -37px;
}
.exclusive .navbar.fixed-top .navbar-brand {
  top: 3px;
}
.exclusive .top_rightnav66 .fa-mobile {
  display: none;
}
.navbar-nav .nav-item .nav-link {
  color: #3E3F45;
}
.exclusive .headerRight .nav-item a {
  width: 45px;
}
.exclusive .headerRight .nav-item a .count {
  right: 3px;
  top: 9px !important;
}
@media (min-width: 1920px) {
  .custom-container{
    min-width: 1920px; 
    margin: 0 auto;
  }
}

</style>



// WEBPACK FOOTER //
// AppNav.vue?51107b30